import styled from 'styled-components';

export const Icon = styled.li<{ content: string; color?: string; hoverColor?: string }>`
    display: inline-block;
    color: ${({ color }) => color || 'white'};
    :hover {
        color: ${({ hoverColor }) => hoverColor || 'black'};
    }
    :before {
        font-family: Icon;
        font-style: normal;
        font-weight: normal;
        speak: none;
        display: inline-block;
        text-decoration: inherit;
        width: 1em;
        margin-right: 0.2em;
        text-align: center;
        font-variant: normal;
        text-transform: none;
        line-height: 1em;
        margin-left: 0.2em;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        content: ${({ content }) => `"${content}"`};
    }
`;

export const SharingLayout = styled.div<{ iconSize?: string }>`
    line-height: 40px;
    font-size: 1.3rem;
    cursor: pointer;
    display: flex;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    z-index: 9;
    align-content: center;
    justify-content: center;
    pointer-events: all;
    color: white;

    a {
        text-decoration: none;
        margin-left: 0.25rem;
    }

    li {
        color: inherit;
    }

    ${Icon} {
        font-size: ${({ iconSize }) => iconSize || '1.3rem'};
    }
`;
